/* unplugin-vue-components disabled */import { render } from "./OpticalPathQuestionEditor.vue?vue&type=template&id=2a063e64&scoped=true"
import script from "./OpticalPathQuestionEditor.vue?vue&type=script&lang=js"
export * from "./OpticalPathQuestionEditor.vue?vue&type=script&lang=js"

import "./OpticalPathQuestionEditor.vue?vue&type=style&index=0&id=2a063e64&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a063e64"]])

export default __exports__